"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BondFutureUnderlyingContract = exports.Definition = exports.BOND_FUTURE_INSTRUMENT_TYPE = void 0;
const default_session_1 = require("../../../../session/default-session");
const Bond = __importStar(require("../bond"));
const financial_contracts_1 = require("../financial-contracts");
const table_builder_1 = require("../table-builder");
exports.BOND_FUTURE_INSTRUMENT_TYPE = 'BondFuture';
function Definition(params) {
    const { outputs, fields, extendedParams, pricingParameters } = params, instrumentDefinition = __rest(params, ["outputs", "fields", "extendedParams", "pricingParameters"]);
    const definition = {
        instrumentType: exports.BOND_FUTURE_INSTRUMENT_TYPE,
        instrumentDefinition,
        pricingParameters,
    };
    const tableBuilder = new table_builder_1.TableBuilderImp();
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const financialContracts = new financial_contracts_1.FinancialContractsProvider(session, tableBuilder);
            return financialContracts.getInstrumentAnalytics([definition], { outputs, fields, extendedParams });
        },
        /** @internal */
        getInstrument() {
            return definition;
        },
    };
}
exports.Definition = Definition;
function BondFutureUnderlyingContract(instrumentDefinition) {
    return Bond.Definition(instrumentDefinition).getInstrument();
}
exports.BondFutureUnderlyingContract = BondFutureUnderlyingContract;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9maW5hbmNpYWwtY29udHJhY3RzL2JvbmQtZnV0dXJlL2RlZmluaXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUNBLHlFQUFpRTtBQUVqRSw4Q0FBZ0M7QUFDaEMsZ0VBQW9FO0FBQ3BFLG9EQUFtRDtBQUV0QyxRQUFBLDJCQUEyQixHQUFHLFlBQVksQ0FBQztBQUV4RCxTQUFnQixVQUFVLENBQ3RCLE1BQWdEO0lBRWhELE1BQU0sRUFBRSxPQUFPLEVBQUUsTUFBTSxFQUFFLGNBQWMsRUFBRSxpQkFBaUIsS0FBOEIsTUFBTSxFQUEvQixvQkFBb0IsVUFBSyxNQUFNLEVBQXhGLDREQUErRSxDQUFTLENBQUM7SUFDL0YsTUFBTSxVQUFVLEdBQUc7UUFDZixjQUFjLEVBQUUsbUNBQTJCO1FBQzNDLG9CQUFvQjtRQUNwQixpQkFBaUI7S0FDcEIsQ0FBQztJQUNGLE1BQU0sWUFBWSxHQUFHLElBQUksK0JBQWUsRUFBRSxDQUFDO0lBRTNDLE9BQU87UUFDSCxPQUFPLENBQUMsVUFBbUIsSUFBQSw0QkFBVSxHQUFFO1lBQ25DLE1BQU0sa0JBQWtCLEdBQUcsSUFBSSxnREFBMEIsQ0FBQyxPQUFPLEVBQUUsWUFBWSxDQUFDLENBQUM7WUFFakYsT0FBTyxrQkFBa0IsQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDLFVBQVUsQ0FBQyxFQUFFLEVBQUUsT0FBTyxFQUFFLE1BQU0sRUFBRSxjQUFjLEVBQUUsQ0FBQyxDQUFDO1FBQ3hHLENBQUM7UUFDRCxnQkFBZ0I7UUFDaEIsYUFBYTtZQUNULE9BQU8sVUFBVSxDQUFDO1FBQ3RCLENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQztBQXRCRCxnQ0FzQkM7QUFJRCxTQUFnQiw0QkFBNEIsQ0FDeEMsb0JBQWlFO0lBRWpFLE9BQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQyxvQkFBMEQsQ0FBQyxDQUFDLGFBQWMsRUFBRSxDQUFDO0FBQ3hHLENBQUM7QUFKRCxvRUFJQyJ9